/** Borrador de activación: sobrevive a una recarga o a perder la señal en terreno (R5.4). */
export interface ActivationDraft {
  code: string;
  domain: string;
  name: string;
  externalRef: string;
  targetUrl: string;
  /** Misma clave en cada reintento: el backend no activa dos veces (R5.3). */
  idempotencyKey: string | null;
}

const KEY = 'qrcl.activationDraft';

export function loadDraft(code: string, domain: string): ActivationDraft | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const draft = JSON.parse(raw) as ActivationDraft;
    return draft.code === code && draft.domain === domain ? draft : null;
  } catch {
    return null;
  }
}

export function saveDraft(draft: ActivationDraft): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(draft));
  } catch {
    /* sin almacenamiento: el borrador vive solo en memoria */
  }
}

export function clearDraft(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* noop */
  }
}
